import { supabase, isDemoMode } from './supabase';

const DEMO_FLAGS = {
  signup_enabled:               true,
  sight_words_tier2_enabled:    false,
  sight_words_tier3_enabled:    false,
  scramble_words_tier2_enabled: false,
  scramble_words_tier3_enabled: false,
  category_words_tier2_enabled: false,
  category_words_tier3_enabled: false,
  math_concepts_enabled:        true,
  daily_living_enabled:         true,
};

export async function getFeatureFlags() {
  if (isDemoMode) return { data: { ...DEMO_FLAGS }, error: null };

  const { data, error } = await supabase
    .from('feature_flags')
    .select('key, enabled');

  if (error) return { data: { ...DEMO_FLAGS }, error };

  const flags = {};
  (data || []).forEach(({ key, enabled }) => { flags[key] = enabled; });
  return { data: flags, error: null };
}

export async function setFeatureFlag(key, enabled) {
  if (isDemoMode) return { error: null };

  return supabase
    .from('feature_flags')
    .update({ enabled })
    .eq('key', key);
}

export async function getTierGrants(activityType) {
  if (isDemoMode) return { data: [], error: null };

  const { data, error } = await supabase
    .from('student_tier_access')
    .select('student_id, tier')
    .eq('activity_type', activityType);

  return { data: data || [], error };
}

export async function getStudentTiers(studentId, activityType) {
  if (isDemoMode) return { data: new Set(), error: null };

  const { data, error } = await supabase
    .from('student_tier_access')
    .select('tier')
    .eq('student_id', studentId)
    .eq('activity_type', activityType);

  return { data: new Set((data || []).map(r => r.tier)), error };
}

export async function grantTierAccess(studentId, activityType, tier, grantedBy) {
  if (isDemoMode) return { error: null };

  return supabase
    .from('student_tier_access')
    .upsert(
      { student_id: studentId, activity_type: activityType, tier, granted_by: grantedBy },
      { onConflict: 'student_id,activity_type,tier' }
    );
}

export async function revokeTierAccess(studentId, activityType, tier) {
  if (isDemoMode) return { error: null };

  return supabase
    .from('student_tier_access')
    .delete()
    .eq('student_id', studentId)
    .eq('activity_type', activityType)
    .eq('tier', tier);
}

export async function getStudentsWithTierAccess(activityType, tier) {
  if (isDemoMode) return { data: new Set(), error: null };

  const { data, error } = await supabase
    .from('student_tier_access')
    .select('student_id')
    .eq('activity_type', activityType)
    .eq('tier', tier);

  return { data: new Set((data || []).map(r => r.student_id)), error };
}
